<div
  data-cy="horizontal-scroll"
  [class]="{
    'horizontal-scroll-container': true,
    'stage-is-scrollable': (isStageScrollable | async)
  }"
>
  <div class="horizontal-scroll-stage-container">
    <div
      class="horizontal-scroll-stage"
      [ngClass]="{
        'flex scroll-smooth snap-x': !scrollByGroup,
        'justify-center':
          centerFixedContent && (isStageScrollable | async) === false
      }"
      #ScrollStage
      (scroll)="updateScrollButtons()"
    >
      <div
        class="horizontal-scroll-item-container p-2 flex"
        #ScrollItemContainer
      >
        <div class="flex gap-x-2">
          <ng-content></ng-content>
        </div>
      </div>
    </div>

    <zelis-button
      data-cy="horizontal-scroll-left-button"
      *ngIf="showControls && !isScrollBeginning"
      class="left-button bg-white"
      [ngClass]="{ 'left-1': !scrollByGroup }"
      color="basic"
      [iconButton]="true"
      [disabled]="false"
      [ariaLabel]="translations.scrollLeft"
      (click)="previousItem()"
      ><mat-icon
        svgIcon="dls-angle-plain-left-light"
        zelisButtonIcon
      ></mat-icon>
    </zelis-button>

    <zelis-button
      data-cy="horizontal-scroll-right-button"
      *ngIf="
        showControls && (!isScrollEnd || (!disableScrollWrap && scrollByGroup))
      "
      class="right-button bg-white"
      [ngClass]="{ 'right-1': !scrollByGroup }"
      color="basic"
      [iconButton]="true"
      [disabled]="false"
      [ariaLabel]="translations.scrollRight"
      (click)="nextItem()"
      ><mat-icon
        svgIcon="dls-angle-plain-right-light"
        zelisButtonIcon
      ></mat-icon>
    </zelis-button>
  </div>

  <div
    class="flex items-center justify-center gap-x-1 mt-4"
    data-cy="horizontal-scroll-progress-dots"
    *ngIf="showProgressDots && scrollByGroup"
  >
    <zelis-dots
      [count]="scrollIndexes.length"
      [dark]="false"
      [selectedIndex]="activeScrollIndex"
      [interactive]="false"
    ></zelis-dots>
  </div>
</div>
